import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react"
import {Box, Typography} from "@mui/material"
import {AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise"
import UseMainListColumnDefs from "./columnDefs";
import "ag-grid-community/styles/ag-grid.min.css"
import "ag-grid-community/styles/ag-theme-balham.min.css"
import "ag-grid-enterprise"
import LOCAL_JA from "../../../../resources/aggrid/locale.ja"
import UseApiManager from "../../../manager/api";
import {AppDataContext, YokohamaDataContext} from "../../../../App";
import _ from "lodash";
import PropTypes from "prop-types";
import MD5 from "md5"

const defaultColDef = {
    floatingFilter: true,
    sortable: true,
}

const MainAgGridComponent = React.memo(
    ({
        onGridReady,
        columnDefs,
        onColumnStateChanged,
        onFilterChanged,
        onFilterModified,
        onRowSelected,
        rowCount,
        getRows,
     }) => {

        const _onGridReady = useMemo(() => onGridReady, [])
        const _columnDefs = useMemo(() => columnDefs, [])
        const _onColumnStateChanged = useMemo(() => onColumnStateChanged, [])
        const _onFilterChanged = useMemo(() => onFilterChanged, [])
        const _onRowSelected = useMemo(() => onRowSelected, [])
        const _onFilterModified = useMemo(() => onFilterModified, [])
        const _defaultColDef = useMemo(() => defaultColDef, [])
        const _rowCount = useMemo(() => rowCount, [])
        const _getRows = useMemo(() => getRows, [])
        const _headerHeight = useMemo(() => 20, [])
        const _rowModeType = useMemo(() => "infinite", [])
        const _datasource = useMemo(() => {return {
            rowCount,
            getRows,
        }}, [rowCount, getRows])
        const _cellSelection = useMemo(() => false, [])
        const _rowSelection = useMemo(() => "single", [])
        const _sideBar = useMemo(() => {
            return {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "列選択",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                        toolPanelParams: {
                            suppressRowGroups: true,
                            suppressValues: true,
                            suppressPivots: true,
                            suppressPivotMode: true,
                            suppressColumnFilter: true,
                            suppressColumnSelectAll: true,
                            suppressColumnExpandAll: true,
                        },
                    },
                ],
            }
        }, [])

    return (
        <AgGridReact
            className="ag-theme-balham"
            columnDefs={_columnDefs}
            onGridReady={_onGridReady}
            onSortChanged={_onColumnStateChanged}
            onColumnResized={_onColumnStateChanged}
            onColumnVisible={_onColumnStateChanged}
            onColumnMoved={_onColumnStateChanged}
            onFilterChanged={_onFilterChanged}
            onFilterModified={_onFilterModified}
            onRowSelected={_onRowSelected}
            defaultColDef={_defaultColDef}
            headerHeight={_headerHeight}
            localeText={LOCAL_JA}
            rowModelType={_rowModeType}
            datasource={_datasource}
            cellSelection={_cellSelection}
            rowSelection={_rowSelection}
            sideBar={_sideBar}
        />
    )
})

MainAgGridComponent.propTypes = {
    columnDefs : PropTypes.any,
    onGridReady: PropTypes.func,
    onColumnStateChanged: PropTypes.func,
    onFilterChanged: PropTypes.func,
    onFilterModified: PropTypes.func,
    onRowSelected: PropTypes.func,
    rowCount: PropTypes.number,
    getRows: PropTypes.func,
}


const MainListView = React.memo(({onReady}) => {

    const { state, setSelectedTree } = useContext(YokohamaDataContext)

    const columnDefs =UseMainListColumnDefs({
        onDetail: (param) => {
            console.log(param)
        }
    })

    const onGridReady = (grid) => onReady(grid.api)

    const [rowCount, setRowCount] = useState()
    const rowDataRef = useRef()
    const { Get, Post } = UseApiManager()

    const getRows = _.debounce(params => {
        console.log('[AgGrid]', 'get rows', params)

        const data = {...params, successCallback: null, failCallback: null}
        if (MD5(JSON.stringify(data)) === rowDataRef.current?.hash) {
            params.successCallback(rowDataRef.current.rows)
            return
        }

        params.successCallback([])

        Post("tree/grid", data, {isRawResponse: true}).then(res => {
            console.log('[AgGrid]', 'get rows response', res)
            if (_.isEmpty(res.data)) {
                params.successCallback([])
                return
            }
            rowDataRef.current = {
                hash: JSON.stringify(data),
                rows: res.data.rows,
            }
            params.successCallback(res.data.rows)
            setRowCount(res.data.rowCount)
        }).catch(e => {
            params.failCallback(e.message)
        })
    }, 1000)
    //
    const onColumnStateChanged = useCallback(() => {

    }, [])

    const onFilterChanged = useCallback(() => {

    }, [])

    const onRowSelected = useCallback((e) => {
        setSelectedTree(e.data)
    }, [])

    return (
        <Box style={{flexGrow: 1}}>
            <MainAgGridComponent
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                onColumnStateChanged={onColumnStateChanged}
                onFilterChanged={onFilterChanged}
                onRowSelected={onRowSelected}
                defaultColDef={defaultColDef}
                rowCount={rowCount}
                getRows={getRows}
            />
        </Box>
    )
})

MainListView.propTypes = {
    onReady: PropTypes.func.isRequired,
}

export default MainListView
